import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.global-this.js";
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, useMediaQuery } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import TAGTypography from './TAGTypography/TAGTypography';
import { makeStyles } from '@mui/styles';
import { ASPENDENTAL_FONTS } from '../../constants/constant';
var BUTTON_BOX_SIZING = {
  marginTop: '-12px',
  marginLeft: '60px',
  marginBottom: '24px',
  paddingTop: '22px',
  paddingBottom: '22px',
  paddingLeft: '28px',
  paddingRight: '28px'
};
export var TAGAccordions = function TAGAccordions(_ref) {
  var accordionBgColorDark = _ref.accordionBgColorDark,
      boxBgColorDark = _ref.boxBgColorDark,
      button = _ref.button,
      buttonText = _ref.buttonText,
      children = _ref.children,
      titles = _ref.titles;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  useEffect(function () {
    var _globalThis$location, _globalThis$location$;

    // to open accordion on page load, when hash value exists in url
    var hashValue = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : (_globalThis$location$ = _globalThis$location.hash) === null || _globalThis$location$ === void 0 ? void 0 : _globalThis$location$.slice(1);

    if (hashValue) {
      var transformedTitles = titles.map(function (title) {
        return title.toLowerCase().replace(/ /gi, '-').replace(/ & /gi, '-');
      });
      var indexOfHashValue = transformedTitles.findIndex(function (title) {
        return title === hashValue;
      });

      if (Math.sign(indexOfHashValue) !== -1) {
        setExpanded("panel".concat(indexOfHashValue));
      }
    }
  }, [globalThis.location]);

  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      event.preventDefault();
      setExpanded(isExpanded ? panel : false);
    };
  };

  var useStyles = makeStyles(function () {
    return {
      MuiAccordionroot: {
        '&.MuiAccordion-root:before': {
          backgroundColor: accordionBgColorDark ? '#F2F3F4' : '#FFFFFF'
        }
      }
    };
  });
  var classes = useStyles();
  var mobileWidth = useMediaQuery('(max-width:600px)');
  var gutterConditional = !boxBgColorDark && !accordionBgColorDark;
  var mobileConditional = gutterConditional && mobileWidth ? 0 : !mobileWidth ? 0 : 0.5;
  return React.createElement(Box, {
    sx: {
      paddingBottom: '10px',
      paddingTop: '10px',
      bgcolor: boxBgColorDark ? 'backgrounds.dark' : 'backgrounds.white',
      boxShadow: 'none'
    }
  }, Array.isArray(children) && children.map(function (child, index) {
    var _titles$index, _child$props, _child$props2, _child$props3, _child$props4;

    return React.createElement(Accordion, {
      key: index,
      className: classes.MuiAccordionroot,
      elevation: 0,
      disableGutters: gutterConditional,
      expanded: expanded === "panel".concat(index),
      onChange: handleChange("panel".concat(index)),
      sx: {
        bgcolor: accordionBgColorDark ? 'backgrounds.neutral' : 'backgrounds.white',
        border: gutterConditional ? '1px solid' : 'none',
        borderColor: gutterConditional ? 'neutrals.primary' : 'none',
        my: mobileConditional
      }
    }, React.createElement(AccordionSummary, {
      sx: [{
        '&.MuiAccordionSummary-root': {
          padding: '16px 20px'
        },
        '.MuiAccordionSummary-content': {
          margin: 0
        },
        flexDirection: mobileWidth ? 'row' : 'row-reverse'
      }],
      expandIcon: React.createElement(ExpandMore, {
        fontSize: "large",
        sx: [{
          color: 'text.interactive'
        }]
      }),
      "aria-controls": "".concat(index, "-content"),
      id: (_titles$index = titles[index]) === null || _titles$index === void 0 ? void 0 : _titles$index.toLowerCase().replace(/ /gi, '-').replace(/ & /gi, '-')
    }, React.createElement(TAGTypography, {
      variant: "h4",
      color: "primary",
      sx: {
        paddingLeft: mobileWidth ? 0 : '16px'
      }
    }, titles[index])), React.createElement(AccordionDetails, {
      sx: {
        display: 'flex',
        flexWrap: 'wrap',
        '&.MuiAccordionDetails-root': {
          padding: mobileWidth ? child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.fullWidth || child !== null && child !== void 0 && (_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.contained ? '0 16px' : 0 : child !== null && child !== void 0 && (_child$props3 = child.props) !== null && _child$props3 !== void 0 && _child$props3.fullWidth || child !== null && child !== void 0 && (_child$props4 = child.props) !== null && _child$props4 !== void 0 && _child$props4.contained ? '0 16px 0 68px' : '0 16px 0 48px'
        }
      }
    }, child), button && React.createElement(Button, {
      variant: "outlined",
      sx: [{
        borderRadius: '32px'
      }, BUTTON_BOX_SIZING, ASPENDENTAL_FONTS.buttonLarge]
    }, buttonText === null || buttonText === void 0 ? void 0 : buttonText.toUpperCase()));
  }));
};
export default TAGAccordions;